import { configureStore } from "@reduxjs/toolkit";
import commonSlice from "./reducers/commonSlice";

export interface storeData{
    common: any
}

export const store = configureStore({
    reducer: {
        common: commonSlice,
    }
});